import { authFetch } from '@/services/apiClient'

// สกิลของฉัน — server คำนวณ x/y จากการเรียนจบจริง (Enrollment COMPLETED) ทุกครั้งที่เรียก
// ตัวหาร = คอร์สที่เผยแพร่ในสกิล ณ ตอนนี้ · สกิลที่ได้รับแล้วไม่หายแม้มีคอร์สใหม่เพิ่ม

export interface MySkillCourse {
  course_id: number
  title: string
  slug: string
  done: boolean
}

export interface MySkill {
  skill_id: number
  name: string
  icon: string
  done: number
  total: number
  /** สกิลเต็ม = เรียนจบครบทุกคอร์สในสกิล */
  earned: boolean
  /** เริ่มสะสมแล้ว = เรียนจบอย่างน้อย 1 คอร์ส */
  started: boolean
  earned_at: string | null
  courses: MySkillCourse[]
}

export interface MySkillCategory {
  category_id: number
  name: string
  skills: MySkill[]
  done: number
  total: number
  earned_count: number
}

export interface MySkillsData {
  categories: MySkillCategory[]
  summary: { earned: number; skills: number; in_progress: number; done_courses: number; all_courses: number }
}

export async function getMySkills(): Promise<MySkillsData> {
  const res = await authFetch('/my-skills')
  let json: { success: boolean; data?: MySkillsData; error?: string; message?: string }
  try {
    json = await res.json()
  } catch {
    throw new Error('เชื่อมต่อเซิร์ฟเวอร์ไม่สำเร็จ')
  }
  if (!json.success || !json.data) throw new Error(json.error || json.message || 'โหลดสกิลไม่สำเร็จ')
  return json.data
}
